var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0158E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.2936V7.70637C7 6.52822 8.29593 5.80995 9.295 6.43437L12.9648 8.728C13.9048 9.3155 13.9048 10.6845 12.9648 11.272L9.295 13.5656C8.29593 14.19 7 13.4718 7 12.2936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaVideo);
export default __webpack_public_path__ + "static/media/media-video.2857bf32d92395b48951f5797ee9c75c.svg";
export { ForwardRef as ReactComponent };